module.exports = __webpack_public_path__ + "static/img/gongzonghao.57aea94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gongzonghao.jpg
// module id = bQhW
// module chunks = 1